import { ChainLayer } from '@cronos-app/sdk';
import { MODAL_MOTION_SCALE_EXIT_DURATION } from '@ui/configs/ui';
import type { ExtendedTokenInfo } from '@ui/views/card-cronos/core/types';
import { create } from 'zustand';

interface UseTokenSelectModalStore {
  isOpen: boolean;
  search: string;
  tokens: ExtendedTokenInfo[];
  onSelectToken?: (token: ExtendedTokenInfo) => void;
  openModal: (options: {
    tokens: ExtendedTokenInfo[];
    onSelectToken?: (token: ExtendedTokenInfo) => void;
  }) => void;
  closeModal: () => void;
}

export const useTokenSelectModal = create<UseTokenSelectModalStore>((set) => ({
  isOpen: false,
  search: '',
  layer: ChainLayer.L1,
  disableCustom: false,
  tokens: [],
  closeModal: () => {
    set({
      isOpen: false,
    });
    // after the modal closing animation ends
    setTimeout(() => {
      set({
        isOpen: false,
        search: '',
        tokens: [],
      });
    }, MODAL_MOTION_SCALE_EXIT_DURATION);
  },
  openModal: ({ onSelectToken, tokens }) => {
    set({
      isOpen: true,
      onSelectToken,
      tokens,
    });
  },
}));
